var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_vm._l((_vm.reports),function(item,index){return _c('v-col',{key:index,attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('report-card-component',{attrs:{"report-content":item},on:{"input":_vm.openDialog}})],1)}),(_vm.showDialog)?_c(_vm.getDialogByType,{tag:"component",on:{"close":_vm.close}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }